import React from "react";
import { twMerge } from "tailwind-merge";

const SectionWrapper = ({
  eyebrow,
  title,
  description,
  children,
  className = "",
  contentClassName = "",
}) => {
  return (
    <section className={twMerge("htb-section py-16 sm:py-20", className)}>
      <div className={twMerge("htb-container mx-auto max-w-7xl px-5 sm:px-6 lg:px-8", contentClassName)}>
        {(eyebrow || title || description) && (
          <div className="htb-section-header mx-auto mb-10 max-w-3xl text-center sm:mb-14">
            {eyebrow && (
              <p className="htb-eyebrow mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand-600">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="htb-section-title font-display text-[32px] font-semibold leading-tight tracking-tight text-slate-900 sm:text-4xl">
                {title}
              </h2>
            )}
            {description && (
              <p className="htb-section-description mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
